import {AxiosResponse} from "axios";
import api from "../../api";
import {TranslationModuleServiceInterface} from "../../types";
import {
    EntityTranslationImportRequest, EntityTranslationImportSaveRequest,
    TranslationEditRequest,
    TranslationImportRequest,
    TranslationImportSaveRequest,
    TranslationListRequest
} from "../../types/request";
import {
    ApplicationTranslationResponse, EntityTranslationImportResponse,
    TranslationEditResponse,
    TranslationImportResponse,
    TranslationListResponse
} from "../../types/response";

export class TranslationService implements  TranslationModuleServiceInterface {
    public import (request: TranslationImportRequest): Promise<AxiosResponse<TranslationImportResponse>> {
        return api.post(`/translator/import_alias_translation`, request);
    }

    public entityImport (request: EntityTranslationImportRequest): Promise<AxiosResponse<EntityTranslationImportResponse>> {
        return api.post(`/translator/import_entity_translation`, request);
    }

    public getImport (): Promise<AxiosResponse<TranslationImportResponse>> {
        return api.get(`/translator/get_alias_translation_import`);
    }

    public getEntityImport (): Promise<AxiosResponse<EntityTranslationImportResponse>> {
        return api.get(`/translator/get_entity_translation_import`);
    }

    public saveImport (request: TranslationImportSaveRequest): Promise<AxiosResponse<TranslationImportResponse>> {
        return api.put(`/translator/confirm_alias_translation_import`, request);
    }

    public saveEntityImport (request: EntityTranslationImportSaveRequest): Promise<AxiosResponse<EntityTranslationImportResponse>> {
        return api.put(`/translator/confirm_entity_translation_import`, request);
    }

    public getExport () {
        return api.get(`/translator/export_alias_translation`, {
            responseType: 'blob',
        });
    }

    public getEntityExport () {
        return api.get(`/translator/export_entity_translation/`, {
            responseType: 'blob',
        });
    }

    public invalidateCache (): Promise<AxiosResponse<{ message: string }>> {
        return api.get(`/translator/invalidate_cache`);
    }

    public edit (request: TranslationEditRequest): Promise<AxiosResponse<TranslationEditResponse>>|any {
        return api.put(`/translator/api/translations/${ request._id }`, request, {
            headers: { 'Content-type': 'application/x-www-form-urlencoded' }
        });
    }

    public list (request: TranslationListRequest): Promise<AxiosResponse<TranslationListResponse>>|any {
        let url = `/translator/api/translations/?page=${request.page}&rows=${request.rows}`;
        let params = request.searchFields.map((item) => `${item.field}=${item.value}`).join('&');
        if (params) { url += `&_search=true&${params}`; }
        return api.get(url);
    }

    public listApplicationLocales(): Promise<AxiosResponse<any>> {
        return api.get(`/translation/locales`);
    }

    public listApplicationTranslations(): Promise<AxiosResponse<ApplicationTranslationResponse>> {
        return api.get(`/translation/`);
    }
}